var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { zodResolver } from '@hookform/resolvers/zod';
import { SATISFACTION_QUESTIONS } from 'root/src/shared/survey/survey.fixtures';
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { surveyEndpointIds } from 'root/src/shared/survey/constants';
import { MAX_RECOMMEND_REASON_LENGTH } from 'root/src/client/v2/survey/constants/satisfactionSurvey.constants';
const submitSatisfactionSurveySchema = z.object({
    recommendStrength: z.enum(SATISFACTION_QUESTIONS.RECOMMEND_STRENGTH.options),
    recommendReason: z.string().min(1, { message: 'Reason is required' }).max(MAX_RECOMMEND_REASON_LENGTH, { message: 'Reason can be at most 200 characters' }),
    issues: z.array(z.enum(SATISFACTION_QUESTIONS.ISSUES.options)).optional(),
    dropRelevance: z.enum(SATISFACTION_QUESTIONS.DROP_RELEVANCE.options).optional(),
    discoveryMethod: z.enum(SATISFACTION_QUESTIONS.DISCOVERY_METHOD.options).optional(),
});
export const useSatisfactionSurveyForm = (surveyId, callback) => {
    const form = useForm({
        resolver: zodResolver(submitSatisfactionSurveySchema),
    });
    const { fetcher } = useDareDropApi();
    const satiscationSurveyMutation = useMutation({
        mutationKey: [],
        mutationFn: (params) => __awaiter(void 0, void 0, void 0, function* () {
            yield fetcher({
                endpointId: surveyEndpointIds.SUBMIT_SATISFACTION_SURVEY,
                payload: params,
            });
            return callback();
        }),
    });
    const onFormSubmit = form.handleSubmit((data) => __awaiter(void 0, void 0, void 0, function* () {
        const answers = [
            {
                questionType: SATISFACTION_QUESTIONS.RECOMMEND_STRENGTH.questionType,
                question: SATISFACTION_QUESTIONS.RECOMMEND_STRENGTH.question,
                options: SATISFACTION_QUESTIONS.RECOMMEND_STRENGTH.options,
                answer: data.recommendStrength,
            },
            {
                questionType: SATISFACTION_QUESTIONS.RECOMMEND_REASON.questionType,
                question: SATISFACTION_QUESTIONS.RECOMMEND_REASON.question,
                answer: data.recommendReason,
            },
            {
                questionType: SATISFACTION_QUESTIONS.ISSUES.questionType,
                question: SATISFACTION_QUESTIONS.ISSUES.question,
                options: SATISFACTION_QUESTIONS.ISSUES.options,
                answer: data.issues,
            },
            {
                questionType: SATISFACTION_QUESTIONS.DROP_RELEVANCE.questionType,
                question: SATISFACTION_QUESTIONS.DROP_RELEVANCE.question,
                options: SATISFACTION_QUESTIONS.DROP_RELEVANCE.options,
                answer: data.dropRelevance,
            },
            {
                questionType: SATISFACTION_QUESTIONS.DISCOVERY_METHOD.questionType,
                question: SATISFACTION_QUESTIONS.DISCOVERY_METHOD.question,
                options: SATISFACTION_QUESTIONS.DISCOVERY_METHOD.options,
                answer: data.discoveryMethod,
            },
        ];
        yield satiscationSurveyMutation.mutateAsync({ surveyId, answers });
    }));
    return {
        form,
        onFormSubmit,
    };
};
